// extracted by mini-css-extract-plugin
export default {"variables":"VariablesButtonSetPlugin-module__variables__iIRD6","text":"VariablesButtonSetPlugin-module__text__0C7vc","button":"VariablesButtonSetPlugin-module__button__QNSPy"};